<template>
  <v-app id="inspire">
    <v-content id="fundo">
      <v-container class="fill-height" fluid>
        <v-row no-gutters  justify="center">
          <v-col
            id="collogo"
            color
            cols="12"
            xl="6"
            lg="4"
            md="5"
            sm="4"
            xs="12"
          >
            <div style="text-align: center; opacity:80%" id="logo">
              <img
                id="imgTopo"
                height="120"
                src="@/assets/logo.png"
                alt="Fabrica"
                class="pt-0 pb-3"
              />
              <!-- <div style="font-weight:bolder;font-size:22px!important">
                CARDÁPIO WEB
              </div>-->
            </div>
          </v-col>
          <v-col cols="12" xl="6" lg="4" sm="2" md="5" xs="12">
            <div id="login">
              <div id="texto">
                <p class="text-left white--text headline">Seja bem-vindo</p>
                <p class="text-left white--text">
                  Entre com seu usuário e senha
                </p>
              </div>
              <v-spacer />
              <v-spacer />

              <v-text-field
                class="white--text"
                name="login"
                v-model="login.email"
                @keyup.enter="mudarCampo('password')"
                prepend-inner-icon="person"
                type="text"
                outlined
                clearable
                background-color="#FFF"
                dense
              />

              <v-text-field
                id="password"
                name="senha"
                @keyup.enter="logar()"
                v-model="login.senha"
                background-color="#FFF"
                prepend-inner-icon="lock"
                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show1 ? 'text' : 'password'"
                @click:append="show1 = !show1"
                outlined
                clearable
                dense
                hide-details="auto"
              />

              <v-btn
                x-small
                text
                block
                class="ml-22 white--text"
                @click="dialogoEsqueci = true"
                >Esqueci a senha</v-btn
              >

              <v-spacer />
              <v-spacer />
              <v-spacer />
              <v-btn
                x-large
                tile
                min-width="200px"
                :loading="loadingbt"
                class="mt-10 ma-0 white--text"
                @click="logar()"
                color="botao_login"
                >Acessar</v-btn
              >
              <v-spacer />

              <div id="logo_tecnoweb"></div>
            </div>
          </v-col>
        </v-row>
        <v-spacer />
        <v-dialog v-model="dialogoEsqueci" max-width="35%">
          <v-card>
            <v-card-title class>
              <span>Esqueci a Senha</span>
              <v-spacer></v-spacer>
              <v-btn icon @click="dialogoEsqueci = false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="8" md="8" lg="8">
                    <v-text-field
                      v-model="esqueci_email"
                      label="E-mail"
                      filled
                      dense
                      clearable
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4" md="4" lg="4">
                    <v-btn
                      color="success"
                      large
                      class="mr-4"
                      @click="esqueciSenha()"
                      >Enviar</v-btn
                    >
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-container>
      <v-snackbar
        style="margin-top:10%"
        :color="error"
        :vertical="mode === 'vertical'"
        v-model="snackbar"
        :timeout="timeout"
        :top="'top'"
      >
        {{ msgErro }}
        <v-btn color="white" text @click="snackbar = false">Fechar</v-btn>
      </v-snackbar>
      <v-snackbar
        style="margin-top:10%"
        :color="botao_sucesso"
        :vertical="mode === 'vertical'"
        v-model="snackbarEsqueci"
        :timeout="timeout"
        :top="'top'"
      >
        Link para redefinição de senha enviado para seu email.
        <v-btn color="white" text @click="snackbar = false">Fechar</v-btn>
      </v-snackbar>
    </v-content>
  </v-app>
</template>

<script>
export default {
  props: {
    source: String,
  },
  data: () => {
    return {
      esqueci_email: "",
      snackbarEsqueci: "",
      dialogoEsqueci: false,
      msgErro: "",
      botao_login: "botao_login",
      botao_sucesso: "botao_sucesso",
      msgEsqueci: "",
      mode: "vertical",
      timeout: 3000,
      error: "error",

      snackbar: false,
      loadingbt: false,
      login: {
        email: "",
        senha: "",
      },
      show1: false,
    };
  },
  methods: {
    mudarCampo(campo) {
      document.getElementById(campo).focus();
    },
    parseJwt(token) {
      var base64Url = token.split(".")[1];
      var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      var jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map(function(c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join("")
      );

      return JSON.parse(jsonPayload);
    },
    async esqueciSenha() {
      if (this.esqueci_email == "") {
        this.snackbar = true;
        this.msgErro = "informe um email!";
        return false;
      }
      await axios
        .post(`grupo/esqueceu_senha`, { email: this.esqueci_email })
        .then((response) => {
          this.snackbarEsqueci = true;
          this.dialogoEsqueci = false;
        })
        .catch((e) => {
          this.snackbar = true;
          this.msgErro = e.response.data;
        });
    },
    async logar() {
      window.sessionStorage.setItem("tokenKey", "");
      this.$access("");
      this.loadingbt = true;
      //var self = axios;
      await axios
        .post(`users/login/gerencia`, this.login)
        .then((response) => {
          if (response.data.error) {
            this.textSnack = response.data.error.cpf;
            this.snackbar = true;
            this.loading = false;
          } else {
            window.sessionStorage.setItem("token", response.data.token);
            //
            window.sessionStorage.setItem("nome", response.data.nome);
            // EventBus.$emit("mudounome");
            window.sessionStorage.setItem("cnpj", response.data.cpf_cnpj);

            setTimeout(() => {
              //window.location.href = "dashboard";
              window.sessionStorage.setItem(
                "tokenKey",
                this.parseJwt(response.data.token).permissoes.split(",")
              );
              this.$access(window.sessionStorage.getItem("tokenKey"));
              this.loadingbt = false;
              this.$router.push("dashboard/monitor")
              // var tokenAccess = this.parseJwt(response.data.token);
            }, 700);
            //return true;
          }

          //  console.log(response.data.token)
        })
        .catch((e) => {
          this.snackbar = true;
          this.msgErro = "Credenciais incorreta!";
          this.loadingbt = false;
        });
    },
  },
};
</script>
<style scoped>
#logo {
  background-color: #f1f1e4;
  height: 500px;
  padding-top: 40%;
  width: 357px;
  vertical-align: bottom;
}
#logo img {
  background-color: #f1f1e4;
  padding-block: 20%;
  vertical-align: bottom;
}
#login {
  background-image: url("~@/assets/fundo_form.png");
  background-size: cover;

  height: 500px;
  padding: 10%;
  width: 357px;
  vertical-align: bottom;
}
#fundo {
  background-image: url("~@/assets/fundo.jpg");
  background-size: cover;
  height: 100%;
}
#logo_tecnoweb {
  background-image: url("~@/assets/logo_tecnoweb.png");
  height: 58px;
  width: 100%;
  text-align: center;
  margin-left: 25%;
  margin-top: 25px;
}
#texto {
  padding-bottom: 20px;
}
@media (max-width: 576px) {
  #collogo {
    display: none !important;
  }
}
</style>
